export const goBack = () => {
  window.history.back();
}

export const getDateAsLocal = (date: Date | undefined) => {
  if (date === undefined) return "";
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join("-") +
    " " +
    [
      padTo2Digits(date.getHours()),
      padTo2Digits(date.getMinutes()),
      padTo2Digits(date.getSeconds()),
    ].join(":")
  );
};

export const splitDate = (stringDate: string) => {
  if (stringDate === undefined || stringDate === null) return;
  const date = stringDate.split("T")[0];
  var time = stringDate.split("T")[1].split(":").slice(0, 2).join(":");
  const sec = stringDate.split("T")[1].split(":").slice(2, 3).join(":");
  time = time + ":" + sec.split(".")[0];
  return { date: date, time: time };
};

export const padTo2Digits = (num: number) => {
  return num.toString().padStart(2, "0");
};